export const primaryNav = [
  { to: '/', label: 'Home' },
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/prediction-strategies', label: 'Strategies' },
  { to: '/why-perfect-predict', label: 'Why PP' },
  { to: '/mt5-infrastructure', label: 'MT5' },
  { to: '/faq', label: 'FAQ' },
] as const

export const footerNav = {
  product: [
    { to: '/how-it-works', label: 'How It Works' },
    { to: '/prediction-strategies', label: 'Prediction Strategies' },
    { to: '/why-perfect-predict', label: 'Why Perfect Predict' },
    { to: '/mt5-infrastructure', label: 'MT5 Infrastructure' },
  ],
  account: [
    { to: '/login', label: 'Login' },
    { to: '/register', label: 'Register' },
    { to: '/contact', label: 'Contact' },
  ],
  legal: [
    { to: '/risk-disclosure', label: 'Risk Disclosure' },
    { to: '/terms', label: 'Terms' },
    { to: '/privacy', label: 'Privacy' },
  ],
} as const

export const strategies = [
  {
    id: 'safe',
    name: 'Safe Prediction',
    tone: 'Conservative stance for steadier participation.',
    points: ['Lower relative exposure', 'Slower conviction changes', 'Ideal for learning the Portal flow'],
    badge: 'Stability first',
  },
  {
    id: 'balanced',
    name: 'Balanced Prediction',
    tone: 'Measured conviction across market conditions.',
    points: ['Moderate stake posture', 'Blend of caution and opportunity', 'Default path for most clients'],
    badge: 'Core approach',
  },
  {
    id: 'aggressive',
    name: 'Aggressive Prediction',
    tone: 'Higher conviction when opportunity is clear.',
    points: ['Faster decision cadence', 'Higher relative exposure', 'For experienced participants'],
    badge: 'High conviction',
  },
] as const

export const sharedAccountFacts = [
  'MT5 Login',
  'Balance',
  'Equity',
  'Positions',
  'History',
  'Deposits',
  'Withdrawals',
] as const

export const mt5Credibility = [
  'Powered by MT5',
  'Executed on MT5',
  'MT5 Verified',
  'MT5 Trading Account',
  'MT5 History',
  'MT5 Infrastructure',
] as const
